import { render, staticRenderFns } from "./problem_details.vue?vue&type=template&id=1bfa2f2c&scoped=true"
import script from "./problem_details.vue?vue&type=script&lang=js"
export * from "./problem_details.vue?vue&type=script&lang=js"
import style0 from "./problem_details.vue?vue&type=style&index=0&id=1bfa2f2c&prod&lang=less&scoped=true"
import style1 from "./problem_details.vue?vue&type=style&index=1&id=1bfa2f2c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa2f2c",
  null
  
)

export default component.exports